import loadable from "@loadable/component";
import type { Locale } from "@ct-react/locale";

const FrenchMessages = loadable.lib(
  () => import(/* webpackChunkName: "intl-fr" */ "./fr-CH.json")
);

const GermanMessages = loadable.lib(
  () => import(/* webpackChunkName: "intl-de" */ "./de-CH.json")
);

const EnglishMessages = loadable.lib(
  () => import(/* webpackChunkName: "intl-en" */ "./en-GB.json")
);

export const getIntlMessages = (locale: Locale) => {
  switch (locale.basename) {
    case "fr":
      return FrenchMessages;

    case "de":
      return GermanMessages;

    case "en":
      return EnglishMessages;

    default:
      throw new Error(`missing translations for locale ${locale.code}`);
  }
};
